import axios from "axios";
import { API_BASE } from "@/lib/api";
import { fixPdfBase64, fixPdfName } from "@/lib/fixPdf";

const KEY = "rpopro_resume_scan_used";
export const savedScan = () => { try { return JSON.parse(localStorage.getItem(KEY)); } catch { return null; } };
export const markScanUsed = (r) => localStorage.setItem(KEY, JSON.stringify(r));

const detail = (e, fallback) => (typeof e.response?.data?.detail === "string" ? e.response.data.detail : fallback);

// POST /public/demo/resume-scan/email (spec §27, live). 422 = bad email (shown, no unlock); other failures still unlock.
export const saveScanEmail = async (r, email, pdfOpts) => {
  const pdf = await fixPdfBase64(r, pdfOpts).catch(() => null);
  try {
    const { data } = await axios.post(`${API_BASE}/public/demo/resume-scan/email`, {
      scan_id: r.scan_id || null, email, score: r.score ?? null, source_page: window.location.pathname,
      ...(pdf ? { pdf_base64: pdf, pdf_filename: fixPdfName(r) } : {}),
    });
    return { ok: true, emailed: !!data?.emailed };
  } catch (e) {
    return { ok: false, invalid: e.response?.status === 422, error: detail(e, "We couldn't save your email just now.") };
  }
};

export const MAX_FILE = 5 * 1024 * 1024;
export const ACCEPT = ".pdf,.doc,.docx,.txt";

// POST /public/demo/resume-scan (spec §18, live). Errors always come back as {detail: "<friendly string>"}.
export const scanResume = async ({ file, text }) => {
  const fd = new FormData();
  if (file) fd.append("file", file);
  if (text) fd.append("text", text);
  try {
    const { data } = await axios.post(`${API_BASE}/public/demo/resume-scan`, fd);
    const rw = data?.rewrite?.before && data?.rewrite?.after ? data.rewrite : null;
    return { ...data, rewrite: rw, ai: true };
  } catch (e) {
    if (!e.response) throw new Error("We couldn't reach the scanner. Check your connection and try again.");
    throw new Error(detail(e, "The scanner is busy right now. Please try again in a minute."));
  }
};
